/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import type { IFiltrosMinhaAgenda, IRespostaListaCompromissos } from "@/interface/agenda-cliente";

const CABECALHOS_JSON = {
  "content-type": "application/json; charset=UTF-8",
  accept: "*/*",
};

/**
 * Agenda do cliente logado. A empresa vem do token (nunca da URL).
 */
const agendaClienteRepository = {
  async getListarMinhaAgenda(
    accessToken: string,
    filtros: IFiltrosMinhaAgenda
  ): Promise<IRespostaListaCompromissos> {
    const instancia = await AxiosService.createAxiosInstance(accessToken);
    const parametros = new URLSearchParams({
      page: String(filtros.page),
      per_page: String(filtros.per_page),
    });
    if (filtros.status) parametros.set("status", filtros.status);
    if (filtros.tipo) parametros.set("tipo", filtros.tipo);
    if (filtros.de) parametros.set("de", filtros.de);
    if (filtros.ate) parametros.set("ate", filtros.ate);
    if (filtros.search) parametros.set("search", filtros.search);

    const resposta = await instancia.get(`minha-agenda?${parametros.toString()}`, {
      headers: CABECALHOS_JSON,
    });
    return resposta.data;
  },
};

/**
 * EXPORTS
 */
export { agendaClienteRepository };
